import type { Dispatch, SetStateAction } from 'react'
import type { SearchState } from '../api/types'

export function SearchBar({
  search,
  setSearch,
  onSearch,
  loading,
  ctaLabel,
}: {
  search: SearchState
  setSearch: Dispatch<SetStateAction<SearchState>>
  onSearch: () => void
  loading: boolean
  ctaLabel?: string
}) {
  return (
    <div className="booking-panel">
      <div className="field">
        <label>Llegada</label>
        <input type="date" value={search.check_in} onChange={(e) => setSearch((prev) => ({ ...prev, check_in: e.target.value }))} />
      </div>
      <div className="field">
        <label>Salida</label>
        <input type="date" value={search.check_out} onChange={(e) => setSearch((prev) => ({ ...prev, check_out: e.target.value }))} />
      </div>
      <div className="field">
        <label>Adultos</label>
        <input type="number" min={1} value={search.adults} onChange={(e) => setSearch((prev) => ({ ...prev, adults: Number(e.target.value) || 1, adultsManuallySet: true }))} />
      </div>
      <div className="field">
        <label>Niños</label>
        <input type="number" min={0} value={search.children} onChange={(e) => setSearch((prev) => ({ ...prev, children: Number(e.target.value) || 0 }))} />
      </div>
      <button className="primary-button" onClick={onSearch} disabled={loading || !search.check_in || !search.check_out}>
        {loading ? 'Buscando...' : (ctaLabel || 'Ver disponibilidad')}
      </button>
    </div>
  )
}
